module.exports = __webpack_public_path__ + "static/00028.1d42c6fe.jpg";